var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebook28 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14 2C10.9801 2.0002 8.07133 3.13894 5.85394 5.18901C3.63654 7.23909 2.27357 10.0498 2.03692 13.0604C1.80028 16.071 2.70737 19.0601 4.57722 21.4315C6.44708 23.8028 9.14223 25.382 12.125 25.8541V17.4687H9.07816V13.9999H12.125V11.3562C12.125 8.34873 13.9165 6.68749 16.6575 6.68749C17.5574 6.7 18.4552 6.77833 19.3437 6.92184V9.87499H17.8306C16.3399 9.87499 15.875 10.8 15.875 11.7489V13.9999H19.2031L18.6711 17.4687H15.875V25.8541C18.8578 25.382 21.5529 23.8028 23.4228 21.4315C25.2926 19.0601 26.1997 16.071 25.9631 13.0604C25.7264 10.0498 24.3635 7.23909 22.1461 5.18901C19.9287 3.13894 17.0199 2.0002 14 2Z",
  fill: "currentColor"
})));
export default SvgFacebook28;